<template>
  <div class="row">
    <div class="col-md-12">
      <fieldset :disabled="pageType === 'view'">
        <div class="widget fluid">
          <div class="whead">
            <h6>Basic Info</h6>
          </div>
          <div class="card-body card-block">
            <form
              action
              method="post"
              enctype="multipart/form-data"
              class="form-horizontal"
              v-on:submit.prevent="save()"
            >
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="name" class="form-control-label" v-required>Name</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder
                    class="form-control"
                    v-model="input.name"
                    ref="name"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="permission" class="form-control-label">Permission</label>
                </div>
                <div class="col-12 col-md-9">
                  <div v-for="(permission, name) in userPermissions" :key="name" class="">
                    <div class="" style="background: white">
                    <div class="row">
                      <div class="col-12 col-md-12">
                      <h5 for class="form-control-label m-2 ml-2">{{ name | capitalize }}</h5>
                      </div>
                    </div>
                    <div class="row" >
                      <div class="col-12 col-md-12">
                      <table class="tDefault" width="100%" style="border-bottom: 1px solid #eee;">
                        <thead>
                          <tr>
                            <td v-for="(item, key) in permission" :key="key">
                              <label>{{ item.name | capitalize }}</label>
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td v-for="(item, key) in permission" :key="key">
                              <input
                                type="checkbox"
                                :value="item.name"
                                v-model="input.permissions_list[item.name]"
                                @click="checkReadPermission($event, item.name)"
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </fieldset>
      <div class="card-footer"></div>
    </div>
  </div>
</template>
<script>

import save from 'src/global/save.js'
import back from 'src/global/back.js'
import getData from 'src/global/getData.js'
import createItem from 'src/global/createItem.js'
import updateItem from 'src/global/updateItem.js'
import validation from 'src/global/validation.js'

export default {
  data() {
    return {
      pageSettings: {
        pageTitle: 'Role & Permissions',
        sectionName: 'user.rolePermission',
        sectionIcon: 'fas fa-users',
        type: this.pageType,
        useDefault: true,
        webService: this.$root.WebService.role,
        modelID: this.$route.params.id ? this.$route.params.id : null,
        navigation: [
          { name: 'User', route: 'user.index' },
          { name: 'Role & Permission', route: 'user.rolePermission.index' },
          { name: this.$route.params.id ? 'Edit' : 'Create' },
        ],
        buttons: [
          (this.pageType !== 'view' ? { name: 'Save', icon: 'fas fa-save', action: this.save } : null),
          { name: 'Back', icon: 'fas fa-arrow-left', action: this.back },
        ],
        subSidebar: {
          buttons: [
            { name: 'User List', icon: 'fas fa-file-download', action: () => { this.$router.push({ name: 'user.index' }) } },
            { name: 'Roles & Permission', icon: 'fas fa-file-download', action: () => { this.$router.push({ name: 'user.rolePermission.index' }) } },
          ]
        }
      },
      input: {
        name: null,
        permissions_list: {}
      },
      requiredInput: [
        {key: 'name', title: 'Name'},
      ],
      userPermissions: null,
      modelID: this.$route.params.id ? this.$route.params.id : null,
      emailExists: false,
      processing: false,
      errorObj: {
        status: false,
        message: null
      },
      timer: null
    }
  },
  props: {
    pageType: String
  },
  created() {
    this.getPermissionList()
    this.getData()
  },
  mounted() {
    this.$emit('setPageHeader', this.pageSettings)
  },
  methods: {
    getPermissionList() {
      this.$http
        .get(this.WebService.permission)
        .then((res) => {
          this.userPermissions = res.data.data
        })
    },
    checkReadPermission($event, name) {
      if($event.target.checked) {
        name = name.split(' ')
        this.input.permissions_list['read ' + name[1]] = true
      }
    },
    back,
    save,
    getData,
    createItem,
    updateItem,
    validation
  }
}
</script>